/* eslint-disable */
const u = navigator.userAgent
const os = {
  isAndroid: function () {
    return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
  },
  isiOS: function () {
    return  !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  }
}

export default os



// WEBPACK FOOTER //
// ./src/utils/os.js